import { useContext } from "react";
import { Image } from "react-bootstrap";
import cx from "classnames";

import styles from "./styles.module.scss";
import { useSelector } from "react-redux";
import _ from "lodash";
import { DealRoomContext } from "../../context";
import { StakeHolderTypeEnum } from "src/types/dealRoom";

const DefaultProfilePicture = "/images/default_user_profile_background.png";

interface UserGroupIconProps {
  className?: string;
  imageSrcs: string[];
}

const avatarClasses = [
  styles.primaryAvatar,
  styles.topAvatar,
  styles.bottomAvatar,
];

const UserGroupIcon: React.FC<UserGroupIconProps> = ({ className, imageSrcs }) => {

  const{ id } = useContext(DealRoomContext);
 const internalStakeholders = useSelector((state) => _.get(state, `dealRooms.dealRoom[${id}].stakeholders.people.[${StakeHolderTypeEnum.INTERNAL}`, {}));
  const externalStakeholders = useSelector((state) => _.get(state, `dealRooms.dealRoom[${id}].stakeholders.people.[${StakeHolderTypeEnum.EXTERNAL}`, {}));

  const groupImageSrcs = buildStakeholderGroupImageSrcs(
    _.get(internalStakeholders, "items", []),
    _.get(externalStakeholders, "items", [])
  );

  const avatars = [...groupImageSrcs.slice(0, 3), ...Array(3).fill(DefaultProfilePicture)].slice(0, 3);

  return (
    <div
      className={cx(styles.container, className)}
    >
      {avatars.map((imageSrc, index) => (
        <Image
          key={`user-group-avatar-${index}`}
          src={imageSrc || DefaultProfilePicture}
          className={cx(styles.avatar, avatarClasses[index])}
        />
      ))}
    </div>
  );
};

export default UserGroupIcon;

const INTERNAL_AVATAR_COUNT = 1;
const EXTERNAL_AVATAR_COUNT = 2;


export const getStakeholderImageSrc = (
  stakeholder: unknown,
  entityPath: "user" | "contact"
): string =>
  _.get(stakeholder, `${entityPath}.icon.thumbnail`, "") ||
  _.get(stakeholder, `${entityPath}.icon.full`, "");

export const buildStakeholderGroupImageSrcs = (
  internalStakeholderItems: unknown[],
  externalStakeholderItems: unknown[]
): string[] => {
  const internalImageSrcs = internalStakeholderItems
    .slice(0, INTERNAL_AVATAR_COUNT)
    .map((stakeholder) => getStakeholderImageSrc(stakeholder, "user"));

  const externalImageSrcs = externalStakeholderItems
    .slice(0, EXTERNAL_AVATAR_COUNT)
    .map((stakeholder) => getStakeholderImageSrc(stakeholder, "contact"));

  return [...internalImageSrcs, ...externalImageSrcs];
};

